import { styled } from '@mui/material'
import { App } from 'features/apps/types'
import CardBase from 'features/common/ui/Cards/CardBase/CardBase'
import { useMeUser } from 'features/users/hooks/useMeUser'
import { useTrackAppSelected } from 'features/apps/hooks/appsHooks'
import HomeAppCardLogo from './HomeAppCardLogo'
import HomeAppCardInfo from './HomeAppCardInfo'
import HomeAppCardGoTo from './HomeAppCardGoTo'
import { CardSize } from './CardSize'

const StyledContainer = styled(CardBase)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1.5),
  justifyContent: 'flex-start'
}))

interface HomeAppsCardProps extends App {
  cardSize: CardSize
  displayDescription: boolean
}

export function HomeAppCard({
  id,
  title,
  description,
  url,
  thumbnail_url,
  displayDescription,
  cardSize
}: HomeAppsCardProps) {
  const user = useMeUser()
  const trackAppSelected = useTrackAppSelected()

  const openApp = () => {
    user && id && trackAppSelected({ user, appId: id })
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <StyledContainer onClick={openApp}>
      <HomeAppCardLogo image={thumbnail_url} title={title} />
      <HomeAppCardInfo title={title} description={description} displayDescription={displayDescription} />
      <HomeAppCardGoTo cardSize={cardSize} />
    </StyledContainer>
  )
}

export default HomeAppCard
